import React from 'react'

import { Button } from 'components/_new/controls'
import type { ButtonProps } from 'components/_new/controls'
import ButtonIcon from 'components/_new/controls/Button/ButtonWithIcons/ButtonIcon/ButtonIcon'
import type { ButtonIconProps } from 'components/_new/controls/Button/ButtonWithIcons/ButtonIcon/ButtonIcon'

import FloatButtonContainer from '../FloatButtonContainer/FloatButtonContainer'

import s from './FloatIconButton.scss'


type FloatIconButtonProps = Pick<ButtonProps, 'color' | 'to' | 'disabled' | 'loading' | 'dataTestId' | 'onClick'> & {
  className?: string
  iconName?: ButtonIconProps['icon']
}

const FloatIconButton: React.FunctionComponent<FloatIconButtonProps> = (props) => {
  const { children, className, iconName, color, to, disabled, loading, dataTestId, onClick } = props

  return (
    <FloatButtonContainer className={className}>
      <Button
        className={s.button}
        to={to}
        size="md"
        color={color}
        disabled={disabled}
        loading={loading}
        onClick={onClick}
        dataTestId={dataTestId}
      >
        {
          Boolean(iconName) && (
            <ButtonIcon icon={iconName} />
          )
        }
        {children}
      </Button>
    </FloatButtonContainer>
  )
}


export default FloatIconButton
